import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

// FIQ-1554: the standard explicit trigger for AI mapping (called by Apply Settings)
export const applyMappingSettings = api(async function applyMappingSettings(id) {
    return mutate(
        gql`
            mutation ApplyMappingSettings($id: String!) {
                applyMappingSettings(id: $id)
            }
        `,
        { id },
        { returns: "applyMappingSettings" }
    )
})
